export class FormInputError {
  constructor(
    public status: string,
    public message: string
  ) {}
}
